import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { Nullable } from '~types/common';

import QueryKeys from '../queryKeys';

export interface WantedCompanyJobs {
  id: number;
  lang: Nullable<string>;
  position: string;
  reward: number;
}

export interface WantedJobPostingResponse {
  company: {
    id: number;
    name: string;
    title_img: string;
    logo_thumb_img: string;
    location: string;
    jobs: WantedCompanyJobs[];
  };
  is_recommended: boolean;
}

export default function useWantedJobPosting(id: string) {
  return useQuery<WantedJobPostingResponse>(
    [QueryKeys.wantedJobPosting, id],
    () => fetcher(`https://www.wanted.co.kr/api/v1/company_briefs?kreditjob_pk=${id}`),
    {
      enabled: !!id,
    },
  );
}
